import React from 'react';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  entityName?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry, entityName = 'data' }) => (
  <div className="text-center py-12">
    <svg className="w-16 h-16 text-red-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">Failed to load {entityName}</h3>
    <p className="text-gray-600 mb-6">{message || 'An error occurred. Please try again.'}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
      >
        Try Again
      </button>
    )}
  </div>
);

export default ErrorState;
